/* ========================================================================
   K-WORLDWIDE — CURSOR CUSTOM JS v3.0
   Tracking mouse + state machine (hover, text, click, hidden).
   Init dopo DOMContentLoaded per evitare flash.
   ======================================================================== */

(function() {
  'use strict';

  // Bail su touch / reduced-motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;

  function init() {
    var cursor = document.createElement('div');
    cursor.className = 'kw-cursor';
    cursor.setAttribute('aria-hidden', 'true');

    var follower = document.createElement('div');
    follower.className = 'kw-cursor-follower';
    follower.setAttribute('aria-hidden', 'true');

    document.body.appendChild(cursor);
    document.body.appendChild(follower);

    var mx = window.innerWidth / 2;
    var my = window.innerHeight / 2;
    var fx = mx, fy = my;
    var firstMove = true;

    function frame() {
      fx += (mx - fx) * 0.18;
      fy += (my - fy) * 0.18;
      cursor.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';
      follower.style.transform = 'translate3d(' + fx + 'px,' + fy + 'px,0)';
      requestAnimationFrame(frame);
    }

    document.addEventListener('mousemove', function(e) {
      mx = e.clientX;
      my = e.clientY;
      if (firstMove) {
        firstMove = false;
        cursor.classList.add('is-ready');
        follower.classList.add('is-ready');
      }
    }, { passive: true });

    var hoverSelector = 'a, button, [role="button"], label, summary, [data-cursor="hover"]';
    var textSelector = 'input[type="text"], input[type="email"], input[type="search"], input[type="url"], input[type="tel"], input[type="password"], input[type="number"], textarea, [contenteditable="true"], [data-cursor="text"]';

    document.addEventListener('mouseover', function(e) {
      if (!e.target.closest) return;
      if (e.target.closest(hoverSelector)) {
        cursor.classList.add('is-hover');
        follower.classList.add('is-hover');
      }
      if (e.target.closest(textSelector)) {
        cursor.classList.add('is-text');
        follower.classList.add('is-text');
      }
    });

    document.addEventListener('mouseout', function(e) {
      if (!e.target.closest) return;
      if (e.target.closest(hoverSelector)) {
        cursor.classList.remove('is-hover');
        follower.classList.remove('is-hover');
      }
      if (e.target.closest(textSelector)) {
        cursor.classList.remove('is-text');
        follower.classList.remove('is-text');
      }
    });

    document.addEventListener('mousedown', function() {
      cursor.classList.add('is-click');
      follower.classList.add('is-click');
    });
    document.addEventListener('mouseup', function() {
      cursor.classList.remove('is-click');
      follower.classList.remove('is-click');
    });

    document.addEventListener('mouseleave', function() {
      cursor.classList.add('is-hidden');
      follower.classList.add('is-hidden');
    });
    document.addEventListener('mouseenter', function() {
      cursor.classList.remove('is-hidden');
      follower.classList.remove('is-hidden');
    });

    requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();